import React from 'react'
import { Excluir } from '../../../../../components/Acoes'
import useOrdenacao from './useOrdenacao'
import './ordenacao.css'

const parseValorFormatado = (str) => {
    const s = (str || '').toString()
        .replace(/[^\d,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
    return parseFloat(s) || 0
}

const colunas = [
    { accessor: 'id', label: 'Cód.', tipo: 'numero', width: '6%' },
    { accessor: 'data_prevista', label: 'Data Prevista', tipo: 'data', width: '10%' },
    { accessor: 'atend_paciente', label: 'Atend. - Paciente', tipo: 'texto' },
    { accessor: 'cliente', label: 'Cliente', tipo: 'texto' },
    { accessor: 'valor_formatado', label: 'Valor', tipo: 'moeda', width: '12%' }
]

const ListaLancamentosLote = ({ lancamentos, onRemoverItem }) => {
    const itensComCampoExtra = (lancamentos || []).map(x => ({
        ...x,
        atend_paciente: `${x.atendimento_id || ''} - ${x.nome_beneficiario || ''}`
    }))

    const { itensOrdenados, alternar, obterClasseTh } = useOrdenacao(itensComCampoExtra)

    const total = (lancamentos || [])
        .reduce((acc, x) => acc + parseValorFormatado(x.valor_formatado), 0)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

    return (
        <div className='card mb-20'>
            <div className='card-body'>
                <div className='mb-3 d-flex align-items-center' style={{ justifyContent: 'space-between' }}>
                    <h5 className='mb-0'>Lançamentos do Lote ({(lancamentos || []).length})</h5>
                    {(lancamentos || []).length > 0 && (
                        <h6>Total: <b>{total}</b></h6>
                    )}
                </div>
                <div className='custom-scrollbar' style={{ maxHeight: 400 }}>
                    <table className='table tabela-porte-acomodacao table-responsive-md table-striped tabela'>
                        <thead className='tabela-lote-ordenavel'>
                            <tr>
                                {colunas.map(c => (
                                    <th key={c.accessor} style={c.width ? { width: c.width } : undefined}
                                        onClick={() => alternar(c.accessor, c.tipo)}>
                                        <div className='group-title-consulta'>
                                            <span className={obterClasseTh(c.accessor)}>{c.label}</span>
                                        </div>
                                    </th>
                                ))}
                                <th className='text-center' style={{ width: '6%' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itensOrdenados.length === 0 ?
                                <tr><td colSpan={colunas.length + 1} className='text-center'><div className='mt-2'>Nenhum lançamento vinculado.</div></td></tr> :
                                itensOrdenados.map(item =>
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.data_prevista}</td>
                                        <td>{item.atend_paciente}</td>
                                        <td>{item.cliente}</td>
                                        <td>{item.valor_formatado}</td>
                                        <td className='text-center'>
                                            <Excluir action={() => onRemoverItem(item)} />
                                        </td>
                                    </tr>
                                )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default ListaLancamentosLote
